const prj = {
  // IDとFormID
  id: buildmode === 'development' ? 698 : 5070,
  form_id: buildmode === 'development' ? 2 : 1,

  // EFOcats化するフォームのセレクタ
  formQuery: 'form.cv_form_input',

  // フォームの中でのページ区切り
  pageQuery: 'tr',

  // ページから中設問を取得するクエリ
  questionQuery: 'th',

  // 必須入力かどうかを取得するクエリ、もしくはテキスト
  requiredQuery: 'img[src="/lp/img/icon_required.png"]',

  // EFOcatsの設置先
  targetQurey: 'body',

  // 送信ボタン
  submitbtnQuery: 'form [name="submitConfirm"]',

  // 先頭ページに戻るボタンを作成するか
  pager_back: true,

  // 先頭ページの戻るボタンをクリックした時に元画面のどのボタンをクリックするか
  pager_back_selector: '#search-btn',

  // 大設問（name属性:テキスト）
  // 複数該当する場合は最後の入力欄のname属性のものが反映されます
  titleList: {
    email: 'メールアドレスをご入力ください。',
    tel_time_0: 'お電話の希望時間帯をご選択ください。',
  },

  // 大設問下の注意書き（name属性:テキストまたはテキストの配列）
  infoList: {
    tel_time_0: ['店舗より初回来店日時の確認でお電話をさせていただきます。'],
    email: '※WEB申込特典のおいしく食べて太らない「健康たんぱく質レシピ」をご希望の方は必ずご入力ください',
  },

  // 設問下の注意書き（name属性:テキストまたはテキストの配列）
  attentionList: {
    entry1_date: ['※Webからのお申し込みは、本日を除いて３営業日以降の受付となります。', '明日・明後日のご来店を希望される場合は、ご希望の店舗にお電話にてお問い合わせください。'],
    tel_time_0: '※ご予約多数の場合、ご希望の時間帯に、お電話できない場合もございます。予めご了承ください。',
  },

  // 中設問（name属性:テキスト）
  // 複数該当する場合は最後の入力欄のname属性で定義してください（他のものは無効）
  labelList: {
    name_1: '',
    age: '',
    tel: '電話番号',
    tel2: '電話番号（確認用）',
    email: '',
    tel_time_empty: '',
    entry1_date: '第1希望（希望日）',
    entry1_time: '第1希望（時間帯）',
    entry2_date: '第2希望（希望日）',
    entry2_time: '第2希望（時間帯）',
    memo_to_shop: 'その他ご希望があればご記入ください',
  },

  // アコーディオン
  accordionList: {},

  // 自動取り込み対象の入力欄の属性
  importAttrs: ['placeholder'],
};

export default prj;
